import { createFileRoute } from '@tanstack/react-router';

import { SupplierBranchesPage } from '@/features/supplier/branches-page';

export const Route = createFileRoute('/_app/supplier/$orgId/branches')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierBranchesPage {...params} />;
}
